/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const mapper = require('object-mapper');

const getRoot = (r: any) => (r?.data ? r.data : r);

const dedupeByUrl = (arr: Array<{ url: string }>) => {
  const seen = new Set<string>();
  return arr.filter(x => (x?.url && !seen.has(x.url) ? (seen.add(x.url), true) : false));
};

const selectImages = (mediaUnion: any) => {
  if (!mediaUnion) return [];
  // MBOP first
  if (mediaUnion?.loyaltyOffers) {
    const los = Array.isArray(mediaUnion.loyaltyOffers) ? mediaUnion.loyaltyOffers : [mediaUnion.loyaltyOffers];
    const out: any[] = [];
    for (const lo of los) {
      const imgs = Array.isArray(lo?.imageData) ? lo.imageData : lo?.imageData ? [lo.imageData] : [];
      for (const d of imgs) {
        const alt = d?.alternateDescription;
        const s = d?.imageUrls?.square,
          f = d?.imageUrls?.featureHorizontal;
        if (s) out.push({ altImageUrl: null, alternateText: alt, url: String(s), __typename: 'PromotionMediaImage' });
        if (f) out.push({ altImageUrl: null, alternateText: alt, url: String(f), __typename: 'PromotionMediaImage' });
        if (out.length >= 2) return dedupeByUrl(out).slice(0, 2);
      }
    }
    return dedupeByUrl(out).slice(0, 2);
  }
  // CTS fallback
  const imgs = Array.isArray(mediaUnion?.images) ? mediaUnion.images : [];
  return imgs
    .filter((i: any) => !!i?.url)
    .map((i: any) => ({
      altImageUrl: i?.altImageUrl ?? null,
      alternateText: i?.alternateText ?? '',
      url: String(i?.url),
      __typename: 'PromotionMediaImage',
    }));
};

const toLegacyPromotionDetail = (promotionById: any, root: any) => {
  if (!promotionById || typeof promotionById !== 'object') return null;

  const node = getRoot(root)?.marketing?.promotions?.promotionById || promotionById;
  const promoId = node?.id ?? null;
  const headlineName = node?.descriptions?.name ?? null;
  const images = selectImages(node?.media);

  // Offer descriptions index & ordered ids
  const ods = Array.isArray(node?.offersDescriptions) ? node.offersDescriptions : [];
  const offerIds = ods.map((r: any) => String(r?.id || '').split('.')[0]).filter(Boolean);
  const descIndex = ods.reduce((acc: Record<string, any[]>, r: any) => {
    const key = String(r?.id || '').split('.')[0];
    if (key) acc[key] = (r?.descriptions ?? []).map((d: any) => ({ key: d?.key, value: d?.value }));
    return acc;
  }, {});

  const offers = offerIds.map((offerId: string) => ({
    descriptions: {
      promotionId: promoId,
      offerId,
      name: null,
      descriptions: descIndex[offerId] || [],
      __typename: 'PromotionOfferDescriptions',
    },
    id: offerId,
    __typename: 'PromotionOffer',
  }));

  return {
    id: promoId,
    name: headlineName ?? null,
    descriptions: { name: headlineName, __typename: 'PromotionDescriptions' },
    media: { images, __typename: 'PromotionMedia' },
    offers,
    __typename: 'Promotion',
  };
};

const promotionByIdTemplate = {
  'marketing?.promotions?.promotionById': {
    key: 'data?.promotion',
    transform: (promotionById: any, root: any) => toLegacyPromotionDetail(promotionById, root),
  },
};

export const mapPromotionByIdToLegacy = (response: any) => mapper(getRoot(response), promotionByIdTemplate);
